module.exports = __webpack_public_path__ + "static/organicrainbow4-dd55b07b9045ff010ad608c922d2f478.png";